module.exports = "../../../../platform/assets/pageMainIcon/industry_yewushezhilei8.svg";